module.exports = __webpack_public_path__ + "static/media/4.69691e88.jpg";